export const GET_ALL_COUNTRIES= 'GET_ALL_COUNTRIES'
export const GET_COUNTRY_DETAIL= 'GET_COUNTRY_DETAIL'
export const ADD_ACTIVITY= 'ADD_ACTIVITY'
export const GET_ALL_ACTIVITIES='GET_ALL_ACTIVITIES'
export const SEARCH_COUNTRY='SEARCH_COUNTRY'
export const FILTERED='FILTERED'
export const UPDATE_PAGE='UPDATE_PAGE'
export const CLEAR_DETAIL='CLEAR_DETAIL'